import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { CONNECTOR_TYPES } from '../../../constants';
import messages from '../../../messages';
import MdaConnectionFailed from './MdaConnectionFailed';
import SccConnectionFailed from './SccConnectionFailed';
const ConnectionFailed = ({ connectorType, selectedChannel, onSetComponent, onSetHeaderMessage })=>{
    useEffect(()=>{
        onSetHeaderMessage(messages.headers.connectedFailed);
        return ()=>onSetHeaderMessage();
    }, []);
    if (connectorType === CONNECTOR_TYPES.SCC) {
        return /*#__PURE__*/ _jsx(SccConnectionFailed, {
            onSetComponent: onSetComponent
        });
    }
    return /*#__PURE__*/ _jsx(MdaConnectionFailed, {
        selectedChannel: selectedChannel,
        onSetComponent: onSetComponent
    });
};
export default ConnectionFailed;
